import { Grid, Toolbar, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomTextField from "../../../../components/CustomTextField";
import Select from "../../../../components/Select/Select";
import { getClinicStocksWoLoader } from "../../../../redux/reducers/clinicSlice";
import {
  getMedicalHistoryByPetId,
  getMedicalHistoryByPetIdWoLoader,
} from "../../../../redux/reducers/medicalHistorySlice";
import { getClinicVets } from "../../../../redux/reducers/vetSlice";
import { AppColors } from "../../../../util/AppColors";
import { serviceTypes } from "../../../../util/dropList";
import { getKey, getRightSaluation } from "../../../../util/function";
import BodyMapView from "../../../CommonScreens/WorkBook/BodyMapView";
import DiagnosticsView from "../../../CommonScreens/WorkBook/DiagnosticsView";
import FileView from "../../../CommonScreens/WorkBook/FileView";
import FormsView from "../../../CommonScreens/WorkBook/FormsView";
import PrescriptionView from "../../../CommonScreens/WorkBook/PrescriptionView";
import PreventiveView from "../../../CommonScreens/WorkBook/PreventiveView";
import ProceduresView from "../../../CommonScreens/WorkBook/ProceduresView";
import SoapNoteView from "../../../CommonScreens/WorkBook/SoapNoteView";
import TreatmentPlanView from "../../../CommonScreens/WorkBook/TreatmentPlanView";
import VitalsView from "../../../CommonScreens/WorkBook/VitalsView";

const arrow = { width: 30, height: 30, color: AppColors.appPrimary };
const initFilter = {
  startDate: null,
  endDate: null,
  serviceTypes: [],
  vetNames: [],
  caseIds: [],
  reasons: [],
  tags: [],
};

const MedicalHistoryNew = ({ petId }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Problem");
  const [searchValue, setSearchValue] = useState("");
  const [samData, setSamData] = useState([]);
  const [heights, setHeights] = useState([]);
  const [page, setPage] = useState(1);
  const [medicalHistoryList, setMedicalHistoryList] = useState([]);
  const [searchValues, setSearchValues] = useState(initFilter);
  const { petMedicalHistoryAll } = useSelector(
    (state) => state?.medicalHistory,
  );
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const petDet = useSelector(
    (state) => state?.pet?.complaintSummary?.data?.pet,
  );
  const { clinicStocks } = useSelector((state) => state?.clinic);
  const itemsPerLoad = 10;
  const listInnerRef = useRef();
  const hasReachedBottomRef = useRef(false);

  useEffect(() => {
    if (petId) {
      dispatch(
        getMedicalHistoryByPetIdWoLoader({
          petId,
          data: {
            type: "all",
            appointmentStatus: ["completed", , "finalize"],
            page: 1,
            itemSize: 50,
          },
        }),
      );
    }
    dispatch(getClinicVets("?type=all"));
    dispatch(getClinicStocksWoLoader());
  }, []);

  useEffect(() => {
    onApiCall(1);
  }, [
    searchValues?.startDate,
    searchValues?.endDate,
    searchValues?.serviceTypes,
    searchValues?.vetNames,
    searchValues?.caseIds,
    searchValues?.reasons,
    searchValues?.tags,
  ]);

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const onApiCall = (currPage = 1) => {
    setPage(currPage);
    const data = {
      type: "all",
      appointmentStatus: ["finalize", "completed"],
      itemSize: itemsPerLoad,
      page: currPage,
    };
    if (searchValues?.startDate) {
      data.startDate = moment(new Date(searchValues?.startDate)).format(
        "YYYY-MM-DD",
      );
    }
    if (searchValues?.endDate || searchValues?.startDate) {
      data.endDate = moment(
        new Date(searchValues?.endDate ?? searchValues?.startDate),
      ).format("YYYY-MM-DD");
    }
    if (searchValues?.serviceTypes?.length > 0) {
      data.serviceTypes = searchValues?.serviceTypes?.map((li) => li?.value);
    }
    if (searchValues?.vetNames?.length > 0) {
      data.vetNames = searchValues?.vetNames?.map((li) => li?.apiValue);
    }
    if (searchValues?.caseIds?.length > 0) {
      data.caseIds = searchValues?.caseIds?.map((li) => li?.value);
    }
    if (searchValues?.reasons?.length > 0) {
      data.reasons = searchValues?.reasons?.map((li) => li?.value);
    }
    if (searchValues?.tags?.length > 0) {
      data.tags = searchValues?.tags?.map((li) => li?.value);
    }
    // if (
    //   (!searchValues?.serviceTypes ||
    //     searchValues?.serviceTypes?.length === 0) &&
    //   (!searchValues?.vetNames || searchValues?.vetNames?.length === 0) &&
    //   (!searchValues?.caseIds || searchValues?.caseIds?.length === 0) &&
    //   (!searchValues?.reasons || searchValues?.reasons?.length === 0) &&
    //   (!searchValues?.tags || searchValues?.tags?.length === 0) &&
    //   (searchValues?.endDate || searchValues?.startDate)
    // ) {
    //   data.type = "range";
    // }
    dispatch(getMedicalHistoryByPetId({ petId, data })).then((res) => {
      if (res?.payload) {
        setMedicalHistoryList([
          ...(currPage === 1 ? [] : (medicalHistoryList ?? [])),
          ...(res?.payload?.data ?? []),
        ]);
      }
    });
  };

  // useEffect(() => {
  //   // Wait for the component to render and then get heights of all w100Per divs
  //   const handleResize = () => {
  //     const elements = document.querySelectorAll(".getHeight");
  //     const newHeights = Array.from(elements).map((el) => el.clientHeight);
  //     setHeights(newHeights);

  //     const lineHeight =
  //       newHeights.length > 1
  //         ? newHeights.reduce((a, b) => a + b, 0) / newHeights.length
  //         : 0;
  //     document.querySelectorAll(".connecting-line").forEach((line) => {
  //       line.style.height = `${lineHeight}px`;
  //     });
  //   };

  //   handleResize(); // Get the initial heights
  //   window.addEventListener("resize", handleResize); // Update heights on window resize
  //   return () => window.removeEventListener("resize", handleResize); // Cleanup event listener
  // }, [samData]);

  const handleOpen = (name, i, value) => {
    const reqData = samData?.map((dta, ind) => {
      if (i === ind) {
        return { ...dta, [name]: { ...dta[name], open: value } };
      }
      return dta;
    });
    setSamData(reqData);
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId,
    );
    return reqStock?.stockBatch ?? [];
  };

  const onScroll = () => {
    if (listInnerRef?.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef?.current;
      const threshold = 10; // Allow 10px threshold for floating point precision
      const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
      const isAtBottom = distanceFromBottom <= threshold;

      if (isAtBottom && !hasReachedBottomRef.current) {
        // console.log("Reached bottom", { scrollTop, scrollHeight, clientHeight, distanceFromBottom });
        hasReachedBottomRef.current = true;
        onApiCall(page + 1);
        // This will be triggered after hitting the last element.
        // API call should be made here while implementing pagination.
      } else if (!isAtBottom && hasReachedBottomRef.current) {
        // Reset flag when scrolling back up
        hasReachedBottomRef.current = false;
      }
    }
  };

  const getVetList = () => {
    const historyVets = (petMedicalHistoryAll?.data ?? [])?.map(
      (li) => li?.doctorId,
    );
    const uniqVetList = uniq(historyVets ?? []);
    const reqVetList =
      (clinicVets ?? [])
        ?.filter(
          (vl) => vl?.status === "Y" && uniqVetList?.includes(vl?.doctorId),
        )
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            apiValue: vet?.name ?? "",
          };
        }) ?? [];
    return reqVetList;
  };

  const getCaseIds = () => {
    const reqList = (petMedicalHistoryAll?.data ?? [])?.map((li) => ({
      name: li?.caseId?.toString(),
      value: li?.caseId?.toString(),
    }));
    return reqList;
  };

  const getSystemList = () => {
    const reqList = (petMedicalHistoryAll?.data ?? [])
      .flatMap((app) => {
        const notes = app?.clinicalNotes || [];
        // If clinicalNotes exist → extract category from tag
        // if (notes?.length > 0) {
        //   return notes?.flatMap((note) => {
        //     const tag = note?.tag;
        //     if (!tag || !tag?.includes("-")) return [];
        //     return [tag?.substring(0, tag?.indexOf("-"))?.trim()];
        //   });
        // }
        // Else → fallback to reason array
        return app?.reason || [];
      })
      ?.filter(Boolean);
    return uniq(reqList ?? [])?.map((li) => ({ name: li, value: li }));
  };

  const getConditionList = () => {
    const reqList = (petMedicalHistoryAll?.data ?? [])
      ?.flatMap((app) => app?.clinicalNotes || [])
      ?.flatMap((note) => {
        return note?.tag;
        // const tag = note?.tag;
        // if (!tag || !tag?.includes("-")) return [];
        // return [tag?.substring(tag?.indexOf("-") + 1)?.trim()];
      })
      ?.filter(Boolean);
    return uniq(reqList ?? [])?.map((li) => ({
      name: li?.substring(li?.indexOf("-") + 1)?.trim(),
      value: li,
    }));
  };

  const handleReset = () => {
    setSearchValues(initFilter);
  };

  return (
    <>
      <div
        className="scroll-80vh w100Per"
        onScroll={onScroll}
        ref={listInnerRef}
      >
        <Grid container className="back-white">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="ph20">
            <Toolbar variant="regular">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row mh20Min">
                  <div className="flex1-end">
                    <div className="w15Per">
                      <CustomTextField
                        value={searchValues?.startDate}
                        name="startDate"
                        handleChange={onSearchChange}
                        label="Start Date"
                        placeholder="Start Date"
                        backgroundColor={AppColors.lightBlue2}
                        mobileDate
                        fullWidth
                      />
                    </div>
                    <div className="w15Per ml20">
                      <CustomTextField
                        value={searchValues?.endDate}
                        name="endDate"
                        handleChange={onSearchChange}
                        label="End Date"
                        placeholder="End Date"
                        backgroundColor={AppColors.lightBlue2}
                        mobileDate
                        fullWidth
                      />
                    </div>
                  </div>
                </div>
                <div className="flex-row-ali-cen mt10 mh20Min flex-space-btwn">
                  <div className="w15Per">
                    <Select
                      list={serviceTypes}
                      value={searchValues?.serviceTypes ?? []}
                      name="serviceTypes"
                      handleChange={onSearchChange}
                      label="Service Type"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w15Per">
                    <Select
                      list={getVetList()}
                      value={searchValues?.vetNames ?? []}
                      name="vetNames"
                      handleChange={onSearchChange}
                      label="Vet Name"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w15Per">
                    <Select
                      list={getCaseIds()}
                      value={searchValues?.caseIds ?? []}
                      name="caseIds"
                      handleChange={onSearchChange}
                      label="Case ID"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w15Per">
                    <Select
                      list={getSystemList()}
                      value={searchValues?.reasons ?? []}
                      name="reasons"
                      handleChange={onSearchChange}
                      label="System"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w15Per">
                    <Select
                      list={getConditionList()}
                      value={searchValues?.tags ?? []}
                      name="tags"
                      handleChange={onSearchChange}
                      label="Condition"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w10Per ">
                    <CustomButton
                      text="Reset"
                      smallBtn
                      redBtn
                      onClick={handleReset}
                    />
                  </div>
                </div>
              </Grid>
            </Toolbar>
            <div>
              {activeTab === "Problem" ? (
                // medicalHistory?.data
                medicalHistoryList?.length > 0 ? (
                  medicalHistoryList?.map((li, i) => {
                    return (
                      <div
                        className="w100Per getHeight"
                        key={getKey()}
                        // style={i !== 0 ? { marginTop: -40 } : { marginTop: 10 }}
                      >
                        <div className="flex-row mt20">
                          <div className="flex-column">
                            <div className="flex-center h50">
                              <div className="gry-dot" />
                            </div>
                            <div
                              style={{
                                width: 1,
                                height: heights?.[i] - 0,
                                background: "#00000033",
                                marginLeft: 5,
                                marginTop: -20,
                              }}
                            />
                          </div>

                          <div
                            className={`w10Per  ${li?.isMaster ? "" : "ml40"}`}
                          >
                            <div className="flex-column flex-center">
                              <Typography className="blue-color txt-semi-bold fs30 mb10Min">
                                {moment(li?.date).format("DD")}
                              </Typography>
                              <Typography className="blue-color txt-semi-bold fs12">
                                {moment(li?.date).format("MMM YYYY")}
                              </Typography>

                              <div
                                className={`mt5 ${
                                  li?.isMaster
                                    ? "org-time-highlight"
                                    : "rse-time-highlight"
                                }`}
                              />
                            </div>
                          </div>
                          <div className="w80Per">
                            <div className="his-bodr">
                              <div className="flex-row-ali-cen p10">
                                <div>
                                  <div className="flex-row-ali-cen">
                                    <Typography className="font-bold fs14 blue-color">
                                      Case ID - {li?.caseId}
                                    </Typography>
                                    <Typography className="light-blue fs14 txt-semi-bold ml10">
                                      {li?.serviceType}
                                      {li?.serviceType === "Consultation"
                                        ? ` | ${
                                            Array.isArray(li?.reason)
                                              ? li?.reason?.join(", ")
                                              : ""
                                          }`
                                        : ""}
                                    </Typography>

                                    {/* <Typography
                                    className={`fs12 font-medium ml10 ${
                                      li?.isMaster
                                        ? "org-tag light-ornge"
                                        : "rose-tag white1"
                                    }`}
                                  >
                                    {li?.isMaster ? "Master" : "Child"}
                                  </Typography> */}
                                    {li?.tags?.map((tg, i) => (
                                      <Typography
                                        className="fs12 font-medium black19 ml10 gry-tag"
                                        key={tg + i}
                                      >
                                        {tg}
                                      </Typography>
                                    ))}
                                  </div>
                                  <div className="flex-row-ali-cen mt10">
                                    <img
                                      src={require("../../../../assets/images/png/calen.png")}
                                      className="img-wh15"
                                    />
                                    <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                      {moment(
                                        new Date(li?.appointmentTime),
                                      ).format("DD MMM YYYY")}
                                    </Typography>
                                    <img
                                      src={require("../../../../assets/images/png/clock.png")}
                                      className="img-wh15 ml10"
                                    />
                                    <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                      {moment(
                                        new Date(li?.appointmentTime),
                                      ).format("HH:mm")}
                                    </Typography>
                                    <img
                                      src={require("../../../../assets/images/png/steath.png")}
                                      className="img-wh15 ml10"
                                    />
                                    <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                      {getRightSaluation(
                                        clinicVets,
                                        li?.doctorId,
                                      )}
                                      {/* {li?.doctorId === li?.clinicId
                                        ? ""
                                        : "Dr. "} */}
                                      {li?.doctorName}
                                    </Typography>
                                  </div>
                                </div>
                                <div className="flex1-end">
                                  <div className="flex-column">
                                    {/* <div className="flex-end">
                                    <Typography
                                      className={`fs12 font-bold white-color ${
                                        li?.status === "Under Treatment" ||
                                        li?.status === "Monitoring"
                                          ? "yellow-tag"
                                          : li?.status === "Inactive"
                                          ? "org-tag"
                                          : li?.status === "Resolved"
                                          ? "grn-tag"
                                          : "red-tag"
                                      }`}
                                    >
                                      {li?.status}
                                    </Typography>
                                  </div> */}
                                    {/* <div className="flex-row-ali-cen mt10">
                                    <Typography className="gray21 fs12 font-medium">
                                      Connections:
                                    </Typography>
                                    <Typography
                                      className={`fs12 font-medium ml5 ${
                                        li?.isMaster ? "rose" : "orange5"
                                      }`}
                                    >
                                      {li?.connections?.length}{" "}
                                      {li?.isMaster ? "Child" : "Master"}
                                    </Typography>
                                  </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="ph5">
                                <div className="gry-hor-split mt5" />
                              </div>
                              <div className="p10">
                                <div key={getKey()}>
                                  {li?.procedures?.filter(
                                    (prd) =>
                                      prd?.appointmentId === li?.appointmentId,
                                  )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "procedures",
                                            i,
                                            !li?.procedures?.open,
                                          );
                                        }}
                                      >
                                        <Typography className="font-bold fs14 blue-color">
                                          Procedures
                                        </Typography>
                                      </div>
                                      <ProceduresView
                                        procedures={li?.procedures?.filter(
                                          (prd) =>
                                            prd?.appointmentId ===
                                            li?.appointmentId,
                                        )}
                                      />
                                    </>
                                  ) : null}
                                  {li?.procedures
                                    ?.filter(
                                      (prd) =>
                                        prd?.appointmentId ===
                                        li?.appointmentId,
                                    )
                                    ?.flatMap(
                                      (proc) => proc?.procedureDetails || [],
                                    )
                                    ?.filter(
                                      (det) =>
                                        det?.type === "Administered" &&
                                        det?.status === "true",
                                    )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "administered",
                                            i,
                                            !li?.administered?.open,
                                          );
                                        }}
                                      >
                                        <Typography className="font-bold fs14 blue-color">
                                          Administered
                                        </Typography>
                                      </div>
                                      <ProceduresView
                                        procedures={li?.procedures?.filter(
                                          (prd) =>
                                            prd?.appointmentId ===
                                            li?.appointmentId,
                                        )}
                                        isAdminister
                                      />
                                    </>
                                  ) : null}
                                  {/* <Typography className="font-bold fs14 blue-color">
                                  Summary
                                </Typography>
                                <Typography className="txt-regular fs12 gray11 ph20">
                                  Test
                                </Typography> */}
                                  {li?.prevetive?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "preventives",
                                            i,
                                            !li?.preventives?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.preventives?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Preventive
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="mr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>

                                      <PreventiveView
                                        preventives={li?.prevetive}
                                      />
                                    </>
                                  ) : null}
                                  {li?.diagnostics?.filter(
                                    (diag) => diag?.dueDate === li?.date,
                                    // li?.status?.toLowerCase() === "completed"
                                  )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "diagnostics",
                                            i,
                                            !li?.diagnostics?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.diagnostics?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Diagnostics
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>

                                      <DiagnosticsView
                                        diagnostics={li?.diagnostics?.filter(
                                          (diag) => diag?.dueDate === li?.date,
                                          // li?.status?.toLowerCase() ===
                                          // "completed"
                                        )}
                                        showFileAlso
                                        isFilePreview
                                      />
                                    </>
                                  ) : null}
                                  {li?.prescription?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "prescriptions",
                                            i,
                                            !li?.prescriptions?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.prescriptions?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Prescription
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="mr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <PrescriptionView
                                        prescriptions={li?.prescription}
                                      />
                                    </>
                                  ) : null}
                                  {(li?.clinicalNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.consolidated,
                                  ) ??
                                  li?.clinicalNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      !cn?.consolidated,
                                  )) ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Soap Notes
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <SoapNoteView
                                        apntId={li?.appointmentId}
                                        soapNote={
                                          li?.clinicalNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.consolidated,
                                          ) ??
                                          li?.clinicalNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              !cn?.consolidated,
                                          )
                                        }
                                      />
                                    </>
                                  ) : null}
                                  {(li?.inpatientNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.type === "surgery" &&
                                      cn?.consolidated,
                                  ) ??
                                  li?.inpatientNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.type === "surgery",
                                  )) ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Surgery Documentation
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <SoapNoteView
                                        apntId={li?.appointmentId}
                                        soapNote={
                                          li?.inpatientNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.type === "surgery" &&
                                              cn?.consolidated,
                                          ) ??
                                          li?.inpatientNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.type === "surgery",
                                          )
                                        }
                                        isSurgery
                                      />
                                    </>
                                  ) : null}
                                  {li?.treatmentPlan?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Protocol Forms
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <TreatmentPlanView
                                        plans={li?.treatmentPlan}
                                      />
                                    </>
                                  ) : null}
                                  {li?.forms?.filter((frm) => frm?.status)
                                    ?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Consent Forms
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <FormsView
                                        forms={li?.forms?.filter(
                                          (frm) => frm?.status,
                                        )}
                                      />
                                    </>
                                  ) : null}
                                  {li?.vitals?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Vitals
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <VitalsView vitals={li?.vitals} />
                                    </>
                                  ) : null}
                                  {li?.bodyMaps?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Body Map
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <BodyMapView bodyMaps={li?.bodyMaps} />
                                    </>
                                  ) : null}
                                  {li?.files?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Files
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <FileView files={li?.files} />
                                    </>
                                  ) : null}
                                  {li?.notes?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "notes",
                                            i,
                                            !li?.notes?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.notes?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="fs14 blue-color font-bold">
                                          Notes
                                        </Typography>
                                      </div>
                                      <Typography className="fs12 txt-regular gray11">
                                        {li?.notes}
                                      </Typography>
                                    </>
                                  ) : null}
                                  {/* <div
                                  className="mt10 flex-row-ali-cen"
                                  onClick={() => {
                                    handleOpen("others", i, !li?.others?.open);
                                  }}
                                >
                                  <Typography className="font-bold fs14 blue-color">
                                    Others
                                  </Typography>
                                </div>

                                {li?.others?.open ? (
                                  li?.others?.list?.length > 0 ? (
                                    li?.others?.list?.map((pre, i) => (
                                      <div
                                        className="mt5 mh10"
                                        key={i + "other"}
                                      >
                                        <div className="gray-back-con1">
                                          <div className="flex-row-wrap1">
                                            <Typography className="fs12 txt-semi-bold black">
                                              Product Name: Anobivac
                                            </Typography>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Vaccine:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                Hepatitis
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Manufacturer:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                Healthcare Plus
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Batch No:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                B2
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Dose:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                1 mg
                                              </Typography>
                                            </div>

                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Administered date & by:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                12 - 06 - 2024 | Dr Rahul
                                              </Typography>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="no-rec">
                                      No records available
                                    </div>
                                  )
                                ) : null}

                                <div className="blue-box-brdr mt10">
                                  <Typography className="font-bold fs14 blue-color">
                                    Additional Notes
                                  </Typography>
                                  <Typography className="txt-regular fs12 gray11 ph20">
                                    {li?.additionalNotes}
                                  </Typography>
                                </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="no-rec h100">No records available</div>
                )
              ) : null}
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default MedicalHistoryNew;
